module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="pages">\r\n  <a href="#" class="active">1</a>\r\n  <a href="#">2</a>\r\n  <a href="#">3</a>\r\n  <a href="#">4</a>\r\n</div>';

}
return __p
}